class StarController {
}

const starComponentDefinition = {
    controller: StarController,
    template: require('./star.component.html').trim(),
    bindings: {
        star: '<',
    },
};

module.exports = {
    StarController,
    starComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/rating/star.component.js